import { Grid } from '@rsa-digital/evo-shared-components/components/Grid';
import LogoLink from '@rsa-digital/evo-shared-components/components/LogoLink';
import spacing from '@rsa-digital/evo-shared-components/helpers/spacing';
import styled from 'styled-components';

export const CtasContainer = styled.div`
  display: flex;
  gap: ${spacing(2)};
`;

export const LogoLinkGrid = styled(Grid)`
  margin: 60px 0;
`;

export const StyledLogoLink = styled(LogoLink)`
  img {
    width: 135px;
  }
`;
